import { combineReducers } from "redux";
import * as actionTypes from "./types";
import { createReducer } from "../../../utils";

const initialVagues = { isLoading: false, data: [], templates: [] };
const initialDetail = { isLoading: false, barometre: null, questions: [], reponses: [], options: null };
const initialSynthese = { isLoading: false, data: null };
const initialHistory = { isLoading: false, data: [] };
const initialAction = { isClassifying: false, isValidating: false };
const initialEmployes = { isLoading: false, data: [], statuts: [] };

const vaguesReducer = createReducer(initialVagues)({
  [actionTypes.GET_VAGUES]: (state) => ({ ...state, isLoading: true }),
  [actionTypes.GET_VAGUES_COMPLETED]: (state, action) => ({
    ...state,
    isLoading: false,
    data: action.payload.result.vagues || [],
    templates: action.payload.result.templates || [],
  }),
  [actionTypes.GET_VAGUES_FAILED]: (state) => ({ ...state, isLoading: false }),
  [actionTypes.VALIDATE_VAGUE_COMPLETED]: (state, action) => {
    const b = action.payload.result.barometre;
    return { ...state, data: state.data.map((v) => (v.id === b.id ? { ...v, ...b } : v)) };
  },
  [actionTypes.DELETE_VAGUE_COMPLETED]: (state, action) => ({
    ...state,
    data: state.data.filter((v) => v.id !== action.payload.id),
  }),
});

const detailReducer = createReducer(initialDetail)({
  [actionTypes.GET_DETAIL]: (state) => ({ ...state, isLoading: true }),
  [actionTypes.GET_DETAIL_COMPLETED]: (state, action) => ({
    ...state,
    isLoading: false,
    barometre: action.payload.result.barometre,
    questions: action.payload.result.questions || [],
    reponses: action.payload.result.reponses || [],
    options: action.payload.result.options || null,
  }),

  [actionTypes.SAVE_EFFECTIF_COMPLETED]: (state, action) => ({
    ...state,
    barometre: state.barometre
      ? { ...state.barometre, effectif: action.payload.result.effectif }
      : state.barometre,
  }),
  [actionTypes.GET_DETAIL_FAILED]: (state) => ({ ...state, isLoading: false }),

  [actionTypes.UPDATE_ITEM_COMPLETED]: (state, action) => {
    const updated = action.payload.result.item;
    return {
      ...state,
      reponses: state.reponses.map((r) => ({
        ...r,
        items: r.items.map((it) => (it.id === updated.id ? updated : it)),
      })),
    };
  },

  [actionTypes.UPDATE_REPONSE_COMPLETED]: (state, action) => {
    const updated = action.payload.result.reponse;
    return {
      ...state,
      reponses: state.reponses.map((r) => (r.id === updated.id ? updated : r)),
    };
  },

  [actionTypes.CREATE_THEME_COMPLETED]: (state, action) => {
    const theme = action.payload.result.theme;
    const questionId = action.payload.questionId;
    return {
      ...state,
      questions: state.questions.map((q) =>
        q.id === questionId ? { ...q, themes: [...(q.themes || []), theme] } : q
      ),
    };
  },

  [actionTypes.UPDATE_THEME_COMPLETED]: (state, action) => {
    const theme = action.payload.result.theme;
    const questionId = action.payload.questionId;
    return {
      ...state,
      questions: state.questions.map((q) =>
        q.id === questionId
          ? { ...q, themes: (q.themes || []).map((t) => (t.id === theme.id ? theme : t)) }
          : q
      ),
    };
  },

  [actionTypes.DELETE_THEME_COMPLETED]: (state, action) => {
    const { themeId, questionId } = action.payload;
    return {
      ...state,
      questions: state.questions.map((q) =>
        q.id === questionId
          ? { ...q, themes: (q.themes || []).filter((t) => t.id !== themeId) }
          : q
      ),
      // les items qui pointaient ce thème repassent à « aucun » (comme en base)
      reponses: state.reponses.map((r) => ({
        ...r,
        items: r.items.map((it) => (it.themeId === themeId ? { ...it, themeId: null } : it)),
      })),
    };
  },

  [actionTypes.VALIDATE_VAGUE_COMPLETED]: (state, action) => ({
    ...state,
    barometre: action.payload.result.barometre,
  }),
});

const syntheseReducer = createReducer(initialSynthese)({
  [actionTypes.GET_SYNTHESE]: (state) => ({ ...state, isLoading: true }),
  [actionTypes.GET_SYNTHESE_COMPLETED]: (state, action) => ({
    ...state,
    isLoading: false,
    data: action.payload.result.synthese,
  }),
  [actionTypes.GET_SYNTHESE_FAILED]: (state) => ({ ...state, isLoading: false }),
});

const historyReducer = createReducer(initialHistory)({
  [actionTypes.GET_HISTORY]: (state) => ({ ...state, isLoading: true }),
  [actionTypes.GET_HISTORY_COMPLETED]: (state, action) => ({
    ...state,
    isLoading: false,
    data: action.payload.result.history || [],
  }),
  [actionTypes.GET_HISTORY_FAILED]: (state) => ({ ...state, isLoading: false }),
});

const actionReducer = createReducer(initialAction)({
  [actionTypes.CLASSIFY]: (state) => ({ ...state, isClassifying: true }),
  [actionTypes.CLASSIFY_COMPLETED]: (state) => ({ ...state, isClassifying: false }),
  [actionTypes.CLASSIFY_FAILED]: (state) => ({ ...state, isClassifying: false }),
  [actionTypes.VALIDATE_VAGUE]: (state) => ({ ...state, isValidating: true }),
  [actionTypes.VALIDATE_VAGUE_COMPLETED]: (state) => ({ ...state, isValidating: false }),
  [actionTypes.VALIDATE_VAGUE_FAILED]: (state) => ({ ...state, isValidating: false }),
});

const employesReducer = createReducer(initialEmployes)({
  [actionTypes.GET_EMPLOYES]: (state) => ({ ...state, isLoading: true }),
  [actionTypes.GET_EMPLOYES_COMPLETED]: (state, action) => ({
    ...state,
    isLoading: false,
    data: action.payload.result.employes || [],
    statuts: action.payload.result.statuts || [],
  }),
  [actionTypes.GET_EMPLOYES_FAILED]: (state) => ({ ...state, isLoading: false }),
  [actionTypes.CREATE_EMPLOYE_COMPLETED]: (state, action) => {
    const e = action.payload.result.employe;
    const data = [...state.data, e].sort((a, b) => a.personne.localeCompare(b.personne));
    return { ...state, data };
  },
  [actionTypes.UPDATE_EMPLOYE_COMPLETED]: (state, action) => {
    const e = action.payload.result.employe;
    return { ...state, data: state.data.map((x) => (x.id === e.id ? e : x)) };
  },
  [actionTypes.DELETE_EMPLOYE_COMPLETED]: (state, action) => ({
    ...state,
    data: state.data.filter((x) => x.id !== action.payload.id),
  }),
});

export default combineReducers({
  vagues: vaguesReducer,
  detail: detailReducer,
  synthese: syntheseReducer,
  history: historyReducer,
  action: actionReducer,
  employes: employesReducer,
});
